import React, { useEffect } from 'react'
import Header from './components/header'
import Footer from './components/footer'
import Offer from './components/about/offer'
import Cta from './components/about/cta';
import Features from './components/about/features';
// import Team from './components/about/team';
// import Fact from './components/about/fact';
// import Partner from "./components/about/partner";
import PageTilte from './components/pageTilte';


// import { Link } from 'react-router-dom';
const About = () => {


    useEffect(() => {

        window.scrollTo(0, 0)

    });

    return (
        <div className="page-wrapper">
            <Header />
            <PageTilte title={'درباره ما'} />


            <Offer />
            <Cta />
            <Features />
            {/* <Team /> */}
            {/* <Fact /> */}
            {/* <Partner /> */}
            <Footer />

        </div>
    );
};

export default About; 